<template>
    <div class="sr-steps">
        <div v-for="(step, index) in steps" :key="index" :class="['item', active >= index ? 'active' : '']">
            <span>{{ index + 1 }}</span>
            {{ step }}
        </div>
        <div class="line" :style="`width: ${(active + 1) * (100 / steps.length).toFixed(2)}%; `"></div>
    </div>
</template>

<script>
export default {
    name: 'steps',
    props: {
        steps: {
            type: Array,
            default() {
                return ['编辑专辑信息', '编辑歌曲信息', '完成编辑/提交审核'];
            }
        },
        align: {
            type: Boolean,
            default: true
        },
        active: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {};
    },
    computed: {},
    methods: {}
};
</script>

<style lang="scss" scoped>
.sr-steps {
    display: flex;
    background-color: $--color-white;
    padding: 20px 0;
    position: relative;

    .item {
        flex: 1;
        text-align: center;
        font-weight: bold;
        color: $-text-500;

        span {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            border: 2px solid $-text-400;
            color: $-text-400;
            text-align: center;
            display: inline-flex;
            align-items: center;
            line-height: 20px;
            justify-content: center;
            margin-right: 8px;
        }

        &.active {
            color: $--color-base;

            span {
                border: 2px solid $--color-base;
                color: $--color-base;
            }
        }
    }

    .line {
        position: absolute;
        left: 0px;
        bottom: 0px;
        height: 2px;
        background: linear-gradient(270deg, #E4E7ED 0%, #5A14EE 100%);
    }

    &.full {
        margin-left: -40px;
        width: calc(100% + 80px);
    }

}
</style>
